export default __webpack_public_path__ + "static/media/hilab-logo.00301b20.svg";